import { useEffect, useState } from "react";
import './Distance.css';

const MULT_DEFAULT = 10;

const Distance = ({ setDistanceMult, estimatedDistance }) => {
  const metersToMiles = (meters) => {
    if (meters === 0) {
      return 0;
    }
    const kilometers = meters / 1000;
    const miles = kilometers * 0.6214;
    return Math.round(miles * 10) / 10;
  }

  const [predictedDistance, setPredictedDistance] = useState(metersToMiles(estimatedDistance));
  const [mult, setMult] = useState(MULT_DEFAULT);
  const [value, setValue] = useState(0);

  const updateSlider = (value) => {
    const newMult = MULT_DEFAULT + value;
    setValue(value);
    setMult(newMult);
    setPredictedDistance(metersToMiles((estimatedDistance / 10) * newMult));
  };

  useEffect(() => {
    setPredictedDistance(metersToMiles(estimatedDistance));
  }, [estimatedDistance]);

  return (
    <div id='distance' className='inner-container'>
      <div className='title'>Distance</div>

      {estimatedDistance === 0 ?
        <div className='text'>LOADING...</div>
        :
        <div className='bump-out'>
          <div className='slider-c'>
            <input
              className='slider'
              type="range"
              min={-10}
              max={20}
              value={value}
              onChange={(e) => updateSlider(Number(e.target.value))}
            />
          </div>

          <div className='text'>Desired Route Distance: {predictedDistance} mi</div>

          <div>
            <button className='button-74' type="button" onClick={() => setDistanceMult(mult)}>Next</button>
          </div>
        </div>
      }
    </div>
  )
}

export default Distance;